module.exports = __webpack_public_path__ + "static/media/welcome.4882d270.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/welcome.svg
// module id = 2081
// module chunks = 0